import { API_BASE, withKey } from './utils';

/**
 * Fetch all global currency markups from the admin table.
 */
export async function fetchMarkups() {
  const url = await withKey(`${API_BASE}/api/fx/markups`);
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch markups');
  return res.json();
}

/**
 * Bulk-save markup percentages.
 * @param {Array<{currency: string, markup_pct: number}>} markups
 */
export async function saveMarkups(markups) {
  const url = await withKey(`${API_BASE}/api/fx/markups`);
  const res = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ markups }),
  });
  if (!res.ok) throw new Error('Failed to save markups');
  return res.json();
}

/**
 * Refresh Nationalbanken rates and recalculate all markups.
 */
export async function refreshMarkups() {
  const url = await withKey(`${API_BASE}/api/fx/markups/refresh`);
  const res = await fetch(url, { method: 'POST' });
  if (!res.ok) throw new Error('Failed to refresh rates');
  return res.json();
}

/**
 * Fetch latest rates WITH global markups applied (for OfferBuilder "Pull New Exchange Rates").
 */
export async function fetchLatestRatesWithMarkups() {
  const url = await withKey(`${API_BASE}/api/fx/latest_with_markups`);
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch rates with markups');
  return res.json();
}
